"use strict";

var _classCallCheck = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/travis/build/comunica/Tutorial-Solid-GraphQL-LD-Profile-Viewer/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actor_abstract_bindings_hash_1 = require("@comunica/actor-abstract-bindings-hash");

var LRU = require("lru-cache");
/**
 * A comunica Reduced Hash Query Operation Actor.
 */


var ActorQueryOperationReducedHash =
/*#__PURE__*/
function (_actor_abstract_bindi) {
  _inherits(ActorQueryOperationReducedHash, _actor_abstract_bindi);

  function ActorQueryOperationReducedHash(args) {
    _classCallCheck(this, ActorQueryOperationReducedHash);

    return _possibleConstructorReturn(this, _getPrototypeOf(ActorQueryOperationReducedHash).call(this, args, 'reduced'));
  }
  /**
   * Create a new distinct filter function for the given hash algorithm and digest algorithm.
   * This will maintain an internal hash datastructure so that every bindings object only returns true once.
   * @param {string} hashAlgorithm A hash algorithm.
   * @param {string} digestAlgorithm A digest algorithm.
   * @return {(bindings: Bindings) => boolean} A distinct filter for bindings.
   */


  _createClass(ActorQueryOperationReducedHash, [{
    key: "newHashFilter",
    value: function newHashFilter(hashAlgorithm, digestAlgorithm) {
      var hashes = new LRU({
        max: this.cacheSize
      });
      return function (bindings) {
        var hash = actor_abstract_bindings_hash_1.AbstractFilterHash.hash(hashAlgorithm, digestAlgorithm, bindings);
        return !hashes.has(hash) && hashes.set(hash, true);
      };
    }
  }]);

  return ActorQueryOperationReducedHash;
}(actor_abstract_bindings_hash_1.AbstractBindingHash);

exports.ActorQueryOperationReducedHash = ActorQueryOperationReducedHash;